import { emitActionViewEvent, emitFreshViewEvent } from "./eventEmitter";

const buildCinema = (cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels, status) => {
    const { labels } = cinemaTracking;
    const parsedCinemaIndex = Number.parseInt(cinemaIndex, 10);
    const featureNumber = Number.isNaN(parsedCinemaIndex)
        ? undefined
        : parsedCinemaIndex === 99
          ? 99
          : parsedCinemaIndex + 1;

    return {
        ...cinemaTracking,
        position: Number(featureIndex),
        status: status,
        labels: {
            ...labels,
            promo_Feature: ["true"],
            promo_FilledSlots: labels.promo_FilledSlots,
            ...(featureNumber && { promo_FeatureNumber: [`${featureNumber}`] }),
            ...additionalTrackingLabels,
        },
    };
};
const buildRecommendation = (recommendationTracking, status) => ({
    ...recommendationTracking,
    status: status,
});

const track = (
    cinemaTracking,
    recommendationTrackings,
    featureIndex,
    cinemaIndex,
    eventMergeId = null,
    additionalTrackingLabels = null,
    actionName = null,
    initialStatus = "loaded"
) => {
    const recommendationEvents = recommendationTrackings.map((it) => buildRecommendation(it, initialStatus));
    const event = [
        buildCinema(cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels, initialStatus),
        ...recommendationEvents,
    ];
    if (eventMergeId) {
        emitActionViewEvent(event, eventMergeId, actionName);
        return;
    }
    emitFreshViewEvent(event);
};

export default track;
